import styled from 'styled-components'

const AlertBadge = styled.span`
  width: .75rem;
  height: .75rem;
  display: block;
  border-radius: 50%;
  background: ${({theme, color}) => color !== 'orange' ? theme.palette.colorRed : theme.palette.colorOrange};
`;
export default AlertBadge


// WEBPACK FOOTER //
// ./src/Observations/containers/AlertBadge.js